
import React, { ReactNode } from "react";
import CustomerPortalNav from "@/components/dashboard/CustomerPortalNav";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { UserCircle } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface CustomerPortalLayoutProps {
  children: ReactNode;
}

const CustomerPortalLayout: React.FC<CustomerPortalLayoutProps> = ({ children }) => {
  const { profile } = useAuth();
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-white">
      <div className="container py-8 animate-fade-in">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-front-gray-900">
            Customer Portal
          </h1>
          <p className="text-front-gray-600 mt-2">
            Manage your plant care services and account details
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="md:col-span-1">
            <div className="mb-4">
              <Card className="overflow-hidden border-front-gray-200 bg-white shadow-sm">
                <CardContent className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="h-12 w-12 rounded-full bg-front-gray-100 flex items-center justify-center text-front-gray-600">
                      {profile?.profileimage ? (
                        <img 
                          src={profile.profileimage} 
                          alt={profile?.name || "User"} 
                          className="h-full w-full rounded-full object-cover" 
                        />
                      ) : (
                        <UserCircle className="h-8 w-8" />
                      )}
                    </div>
                    <div>
                      <p className="font-semibold text-front-gray-900">{profile?.name || "Welcome"}</p>
                      <p className="text-xs text-front-gray-600">{profile?.email || ""}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
            <CustomerPortalNav />
          </div>
          
          <div className="md:col-span-3">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerPortalLayout;
